export default "__VITE_PUBLIC_ASSET__4339717a__"